module.exports = __webpack_public_path__ + "img/1.876af2c2.webp";